export default __webpack_public_path__ + "static/media/appstore.c1099558.webp";